import React from 'react';
import { IconProps } from '../IconProps';

export const ResetCWAIcon: React.FC<IconProps> = ({
	width = 17,
	height = 17,
	fill = 'currentColor',
	className,
}) => (
	<svg
		width={width}
		height={height}
		viewBox="0 0 17 17"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		aria-hidden="true"
		className={className}
	>
		<g clipPath="url(#reset-cwa-clip)">
			<path
				d="M8.25201 1.23161e-05C8.82577 -0.0025124 9.24983 0.383387 9.25201 0.917981C9.25396 1.45496 8.84185 1.83899 8.26373 1.84669C4.78606 1.89243 2.02122 4.59234 1.8399 8.12111C1.67066 11.4181 4.21721 14.3826 7.56549 14.7852C9.05807 14.9645 10.4815 14.6188 11.6671 13.9024V15.959C11.4762 16.0428 11.2811 16.1211 11.0821 16.1914C5.68972 18.0953 -0.0215049 14.0387 6.08856e-05 8.32032C0.017672 3.74925 3.71585 0.0200632 8.25201 1.23161e-05ZM8.2608 3.71681C8.90161 3.71211 9.3582 4.22161 9.24225 4.8213C9.15548 5.26988 8.78584 5.5596 8.29205 5.57325C7.05688 5.6075 6.00704 6.40054 5.68561 7.55177C5.3749 8.66529 5.6497 9.6322 6.49908 10.3897C7.35624 11.154 8.35588 11.3198 9.40631 10.8682C10.4686 10.4112 11.0338 9.56219 11.088 8.37111C11.1068 7.95915 11.2748 7.66678 11.6163 7.50197C11.9437 7.34396 12.2764 7.37649 12.5723 7.59474C12.811 7.77073 12.9355 8.01928 12.9424 8.32228C12.9946 10.6189 11.1243 12.71 8.83014 12.9199C8.73741 12.9284 8.65914 12.9339 8.49908 12.9443C8.41305 12.95 8.37808 12.952 8.33502 12.9551L8.32819 12.8584V12.9561C5.79116 12.9484 3.72433 10.888 3.7149 8.35646C3.7058 5.82217 5.74973 3.7356 8.2608 3.71681ZM14.8204 8.41407C14.8318 7.76175 15.3089 7.32338 15.9014 7.43165C16.3603 7.5157 16.6618 7.9023 16.6573 8.3965C16.6467 9.54865 16.3996 10.6564 15.9571 11.667H13.8946C14.4624 10.7188 14.7998 9.60993 14.8204 8.41407ZM8.33405 7.35841C8.87101 7.36182 9.30274 7.80003 9.29987 8.33888C9.2967 8.88177 8.86752 9.3067 8.3233 9.3047C7.78127 9.30251 7.35509 8.87175 7.35748 8.32814C7.35998 7.78998 7.79778 7.35518 8.33405 7.35841Z"
				fill={fill}
			/>
		</g>
		<defs>
			<clipPath id="reset-cwa-clip">
				<rect width="16.6667" height="16.6667" fill="white" />
			</clipPath>
		</defs>
	</svg>
);
